import ManageWorkspaceController from '../modals/manage_workspace_controller'
import Events from '../../events'

//TODO needs loader spinner

const WorkspaceController = function ($routeParams, $scope, $location,featureToggles, ModalService, dataService,
                                      initialDataInteractor, workspaceInteractor, eventsService) {
  const $ctrl = this;

  $scope.featureEnabled = (feature) => featureToggles.isAvailable(feature);

  initialDataInteractor.ensureInitializedSession()
    .then(() => workspaceInteractor.getWorkspace($routeParams[ 'id' ])
      .then(workspace => {
        $ctrl.workspace = workspace;
        $scope.$broadcast(Events.LOAD_COMPLETE);
        $scope.$digest();
      }))
    .catch(err => eventsService.publishSystemError(`Error initializing: ${err.message}`));

  $ctrl.isWorkspaceOwner = function() {
    return $ctrl.workspace && $ctrl.workspace.owner === dataService.person.id;
  };

  $ctrl.manageWorkspace = function () {
    ModalService.showModal({
      templateUrl: 'modals/manage_workspace.html',
      controllerAs: '$ctrl',
      controller: ManageWorkspaceController,
      inputs: {
        workspace: $ctrl.workspace,
        rename: $ctrl.updateWorkspaceName,
        deleteWorkspace: $ctrl.deleteThisWorkspace
      }
    }).then(modal => {
      modal.close.then(() => {
      })
    })
  };

  //TODO: Make this use confirm button
  $ctrl.deleteThisWorkspace = function () {
    let confirmed = window.confirm("Are you sure that you want to delete this workspace? You won't be able to recover it.");
    if (confirmed) {
      workspaceInteractor.deleteWorkspace($ctrl.workspace.id)
        .then(() => {
          eventsService.publishSystemMessage('Workspace successfully deleted');
          $scope.$apply(() => $location.path('/workspaces'))
        })
        .catch(error => eventsService.publishSystemError(error));
    }
  };

  $ctrl.updateInvestigations = function () {
    $scope.$broadcast(Events.UPDATE_WORKSPACE_INVESTIGATIONS, {});
    $scope.$digest();
  };

  $ctrl.updateWorkspaceName = function (name) {
    workspaceInteractor.updateWorkspace($ctrl.workspace.people, $ctrl.workspace.id, name)
      .then(() => {
        eventsService.publishSystemMessage('Workspace successfully renamed');
        $scope.$digest();
      })
      .catch(error => eventsService.publishSystemError(error));
  };
};

export default {
  name: 'WorkspaceController',
  fn: WorkspaceController
};